import { useSelector } from "react-redux";

const AccountDetailWidgetLogic = () => {
  const { account_name, bank_name, account_number } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  return { account_name, bank_name, account_number };
};
export default AccountDetailWidgetLogic;
